import React, {FC} from 'react';
import './style.scss';
import classNames from "classnames";

interface IAddTastesButton {
    isActive: boolean
}

const AddTastesButton: FC<IAddTastesButton> = ({isActive}) => {
    return (
        <div className="add">
            <div className={classNames({
                "add__container": true,
                "add__container--active": isActive
            })}>
            </div>
        </div>
    )
};

export default AddTastesButton;
